import { createFileRoute } from '@tanstack/react-router'
import { Mail } from 'lucide-react'
import { z } from 'zod'
import { Button, Text } from '../components/ui'

const verifyEmailSearchSchema = z.object({
  email: z.string().optional(),
})

export const Route = createFileRoute('/verify-email')({
  validateSearch: verifyEmailSearchSchema,
  component: VerifyEmailPage,
})

function VerifyEmailPage() {
  const { email } = Route.useSearch()

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6">
      <div className="w-full max-w-md text-center">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-stone">
          <Mail className="h-7 w-7 text-foreground" />
        </div>
        <Text variant="h1" className="mb-3">
          Check your inbox
        </Text>
        <Text variant="body" className="mb-2 text-foreground/60">
          We sent a verification link to
        </Text>
        {email && (
          <Text variant="body-sm" className="mb-6 font-semibold">
            {email}
          </Text>
        )}
        <Text variant="body-sm" className="mb-8 text-foreground/60">
          Click the link in the email to verify your account, then log in to access your workspace.
        </Text>
        <Button variant="outline" onClick={() => window.location.assign('/login')}>
          Go to login
        </Button>
      </div>
    </div>
  )
}
